// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trial-balance-wrapper .trial-balance-title[data-v-3105cb26] {\n  font-size: 2rem;\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
